import React, { useState, useEffect, useContext } from "react";
import { Collapse, Form, Select, Input, Modal, message, Upload } from "antd";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import moment from "moment";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import ServiceApi, { authUser } from "../../../../services/ServiceApi";
import reqwest from "reqwest";
import Fixproblemdetail from "./Fixed_Problem_detail";

import { dynamicFunction } from "../../../../pages/uih/wf_controllers/BtnController/dynamicFunction";
import { handleForm } from "../../../../contexts";
import { StatusInfo } from "../../../utility/status_info_modal";
import {
  defaultFormItemLayout,
  tailLayout,
} from "../../../utility/form_layout";
import { async } from "q";
const { Panel } = Collapse;
const { Option } = Select;

// const formItemLayout = {
//   labelCol: { span: 6 },
//   wrapperCol: { span: 14 },
// };
// const tailLayout = {
//   wrapperCol: { offset: 8, span: 16 },
// };
const FixedProblem = (props) => {
  // const [form] = Form.useForm();
  const { form } = useContext(handleForm);
  const auth = authUser();
  const {
    CompanyId,
    OperatorId,
    ProjectId,
    jobData,
    headerdata,
    Workflowdata,
  } = props;
  const [jobMaintenance] = jobData.result_maintenance ?? [null];
  const [jobAssetdetail] = jobData.result_assetdetail ?? [null];
  const [reRenderFixProblemList, setreRenderFixProblemList] = useState(false);
  const [selectJobFixedID, setselectJobFixedID] = useState(null);

  const [formData, setFormData] = useState({
    slaList: [],
    jobCauses: [],
    jobSubCauses: [],
    jobTier3: [],
    actions: [],
  });
  const [initValueForm, setinitValueForm] = useState({
    jobSLA: null,
    jobCause: null,
    jobSubCause: null,
    action: null,
    problemDetail: null,
    tier3_id: null 
  });

  const [disableSubmit, setDisableSubmit] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [uploadImg, setuploadImg] = useState([]);
  const [initValueorNot, setinitValueorNot] = useState(false);
  const [insertOrUpdate, setinsertOrUpdate] = useState(false);
  const [spin, setspin] = useState(true);
  const [loadingText, setloadingText] = useState("Loading Action");
  const [statusInfoMode, setstatusInfoMode] = useState("success");
  const callFunction = new dynamicFunction(
    CompanyId,
    OperatorId,
    ProjectId,
    headerdata,
    null,
    setVisibleModal,
    setloadingText,
    setspin,
    setstatusInfoMode,
    form
  );
  const handleChangeJobCause = (value) => {
    ServiceApi.post("master_data/job_sub_cause", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      cause_id: value,
    })
      .then(({ data: res }) => {
        const { result, data } = res;

        if (result.code === "P" || result.value === "P") {
          const jobSubCausesList = data?.result.map((s) => ({
            ...s,
            value: s.sub_cause_id,
            label: `${s.subCause_Desc1} : ${s.subCause_Desc2}`,
          }));

          form.setFieldsValue({ jobSubCause: null , tier3_id : null });

          setFormData({
            ...formData,
            jobSubCauses: jobSubCausesList,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleChange = (info) => {
    if (info.file.status === "done") {
      setuploadImg([...uploadImg, { ...info.file, action: "ADD" }]);
    }
  };

  const onFinish = (values) => {
    setDisableSubmit(true);
    setVisibleModal(true);
    setloadingText("Insert Job Fixproblem");
    if (insertOrUpdate) {
      UpdateFixed(values);
    } else {
      insertFixproblem(values);
    }
  };
  function insertFixproblem(values) {
    const sendBtn = Workflowdata?.filter(
      (s) => s.next_main_action_id === 13
    )[0];
    ServiceApi.post("job_detail/Insertjobfixproblem", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_FixProblem_id: "0",
      job_progress_id: jobAssetdetail?.job_progress_id,
      job_id: jobAssetdetail?.job_id,
      job_status_id: jobMaintenance?.job_status,
      SLA_Id: values.jobSLA || null, //! data
      maintain_type_id: values.maintainType || null,
      owner_network_id: values.ownerNetwork || null,
      Cause_Id: values.jobCause || null, //! data
      SubCause_Id: values.jobSubCause || null, //! data
      Action_Id: values.action || null, //! data
      problem_detail: values.problemDetail || null, //! data
      Is_Disable: values.isDisable ? 1 : 0, //! data
      exclusion_detail: values.exclusion_detail || null, //! data
      FixProblem_Result: values.FixProblem_Result || null, //! data
      tier3_id: values.tier3_id ,
      is_active: 1,
      create_date: moment().format(),
      update_date: moment().format(),
      delete_date: "2020-12-12",
      form_id: "",
      data_dynamic: "",
      create_by: auth.username,
      ...sendBtn,
    })
      .then(({ data: res }) => {
        const { result, data } = res;
        //setDisableSubmit(false);
        if (result.code === "P") {
          const currentjobfixproblemid =
            data.oper_job_fixproblem[0].job_FixProblem_id;
          //  form.resetFields();
          if (uploadImg.length > 0) {
            setloadingText("Upload Picture");
            const images = new FormData();
            uploadImg
              .filter((s) => s.action === "ADD")
              .forEach((file) => {
                images.append("files", file?.originFileObj);
                images.append("job_id", jobAssetdetail?.job_id);
                images.append(
                  "job_progress_id",
                  jobAssetdetail?.job_progress_id
                );
                images.append("company_id", CompanyId);
                images.append("operator_id", OperatorId);
                images.append("project_id", ProjectId);
                images.append(
                  "job_category_id",
                  jobAssetdetail?.job_category_id
                );
                images.append("job_type_id", jobMaintenance?.jobtypeid);
                images.append("asset_id", jobAssetdetail?.asset_id);
                images.append("create_by", auth.username);
                images.append("pic_type", "F");
                images.append("job_reference_id", currentjobfixproblemid);
              });
            reqwest({
              url: `${process.env.REACT_APP_URL_API}job_detail/InsertImageListFile`,
              method: "post",
              processData: false,
              data: images,
              headers: {
                TokenUser: auth.token,
              },
              success: () => {
                uploadImg
                  .filter((s) => s.action === "ADD")
                  .forEach((file) => {
                    images.delete("files", file?.originFileObj);
                    images.delete("job_id", jobAssetdetail?.job_id);
                    images.delete(
                      "job_progress_id",
                      jobAssetdetail?.job_progress_id
                    );
                    images.delete("company_id", CompanyId);
                    images.delete("operator_id", OperatorId);
                    images.delete("project_id", ProjectId);
                    images.delete(
                      "job_category_id",
                      jobAssetdetail?.job_category_id
                    );
                    images.delete("job_type_id", jobMaintenance?.jobtypeid);
                    images.delete("asset_id", jobAssetdetail?.asset_id);
                    images.delete("create_by", auth.username);
                    images.delete("pic_type", "F");
                    images.delete("job_reference_id", currentjobfixproblemid);
                  });

                setuploadImg(
                  uploadImg.map((item) => ({ ...item, action: "UPDATE" }))
                );
                message.success("upload successfully.");
              },
              error: () => {
                message.error("upload failed.");
              },
            });
          }
          if (
            sendBtn.external_url_type &&
            sendBtn.external_url_type === "json"
          ) {
            setloadingText("Loading External URL");
            callFunction.CallExternalurl(JSON.parse(sendBtn.external_url));
          } else {
            setloadingText("Success");
            setspin(false);
          }
          setTimeout(() => {
            setreRenderFixProblemList(!reRenderFixProblemList);
          }, 2000);
        } else {
          setloadingText(`Error : ${result?.showText}`);
          setstatusInfoMode("error");
          setspin(false);
        }
      })
      .catch((err) => {
        setloadingText(`Error : ${err}`);
        setstatusInfoMode("error");
        setspin(false);
      });
  }
  function UpdateFixed(values) {
    const sendBtn = Workflowdata?.filter(
      (s) => s.next_main_action_id === 13
    )[0];
    ServiceApi.post("job_detail/jobUpdatefixproblem", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_FixProblem_id: selectJobFixedID ? selectJobFixedID : "0",
      job_progress_id: jobAssetdetail?.job_progress_id,
      job_id: jobAssetdetail?.job_id,
      job_status_id: jobMaintenance?.job_status,
      SLA_Id: values.jobSLA || null, //! data
      maintain_type_id: values.maintainType || null,
      owner_network_id: values.ownerNetwork || null,
      Cause_Id: values.jobCause || null, //! data
      SubCause_Id: values.jobSubCause || null, //! data
      Action_Id: values.action || null, //! data
      problem_detail: values.problemDetail || null, //! data
      Is_Disable: values.isDisable ? 1 : 0, //! data
      exclusion_detail: values.exclusion_detail || null, //! data
      FixProblem_Result: values.FixProblem_Result || null, //! data
      tier3_id: values.tier3_id ,
      is_active: 1,
      create_date: moment().format(),
      update_date: moment().format(),
      delete_date: "2020-12-12",
      form_id: "",
      data_dynamic: "",
      create_by: auth.username,
      ...sendBtn,
    })
      .then(({ data: res }) => {
        const { result } = res;
        // setDisableSubmit(false);
        if (result.code === "P" || result.value === "P") {
          const currentjobfixproblemid = selectJobFixedID;
          //  form.resetFields();
          if (uploadImg.length > 0) {
            setloadingText("Upload Picture");
            const images = new FormData();
            uploadImg
              .filter((s) => s.action === "ADD")
              .forEach((file) => {
                images.append("files", file?.originFileObj);
                images.append("job_id", jobAssetdetail?.job_id);
                images.append(
                  "job_progress_id",
                  jobAssetdetail?.job_progress_id
                );
                images.append("company_id", CompanyId);
                images.append("operator_id", OperatorId);
                images.append("project_id", ProjectId);
                images.append(
                  "job_category_id",
                  jobAssetdetail?.job_category_id
                );
                images.append("job_type_id", jobMaintenance?.jobtypeid);
                images.append("asset_id", jobAssetdetail?.asset_id);
                images.append("create_by", auth.username);
                images.append("pic_type", "F");
                images.append("job_reference_id", currentjobfixproblemid);
              });
            reqwest({
              url: `${process.env.REACT_APP_URL_API}job_detail/InsertImageListFile`,
              method: "post",
              processData: false,
              data: images,
              headers: {
                TokenUser: auth.token,
              },
              success: () => {
                uploadImg
                  .filter((s) => s.action === "ADD")
                  .forEach((file) => {
                    images.delete("files", file?.originFileObj);
                    images.delete("job_id", jobAssetdetail?.job_id);
                    images.delete(
                      "job_progress_id",
                      jobAssetdetail?.job_progress_id
                    );
                    images.delete("company_id", CompanyId);
                    images.delete("operator_id", OperatorId);
                    images.delete("project_id", ProjectId);
                    images.delete(
                      "job_category_id",
                      jobAssetdetail?.job_category_id
                    );
                    images.delete("job_type_id", jobMaintenance?.jobtypeid);
                    images.delete("asset_id", jobAssetdetail?.asset_id);
                    images.delete("create_by", auth.username);
                    images.delete("pic_type", "F");
                    images.delete("job_reference_id", currentjobfixproblemid);
                  });

                setuploadImg(
                  uploadImg.map((item) => ({ ...item, action: "UPDATE" }))
                );
                message.success("upload successfully.");
              },
              error: () => {
                message.error("upload failed.");
              },
            });
          }
          if (
            sendBtn.external_url_type &&
            sendBtn.external_url_type === "json"
          ) {
            setloadingText("Loading External URL");
            callFunction.CallExternalurl(JSON.parse(sendBtn.external_url));
          } else {
            setloadingText("Success");
            setspin(false);
          }
          setTimeout(() => {
            setreRenderFixProblemList(!reRenderFixProblemList);
          }, 2000);
        } else {
          setloadingText(`Error : ${result?.showText}`);
          setstatusInfoMode("error");
          setspin(false);
        }
      })
      .catch((err) => {
        setloadingText(`Error : ${err}`);
        setstatusInfoMode("error");
        setspin(false);
      });
  }
  useEffect(() => {
    ServiceApi.post("job_detail/get_jobfixproblem_list", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_id: jobAssetdetail?.job_id,
    })
      .then((res) => {
        if (res?.data.result?.code === "P") {
          if (res.data.data?.job_fixproblem_List.length > 0) {
            const firstRes = res.data.data.job_fixproblem_List[0];
            setinitValueForm({
              jobSLA: firstRes.slA_Id,
              maintainType: firstRes.maintain_type_id,
              jobCause: firstRes.cause_Id,
              jobSubCause: firstRes.subCause_Id,
              action: firstRes.action_Id,
              problemDetail: firstRes.fixProblem_detail,
              ownerNetwork: firstRes.owner_network_id,
              exclusion_detail: firstRes.exclusion_detail,
              FixProblem_Result: firstRes.fixProblem_Result,
              tier3_id: firstRes.tier3_id
            });
            setselectJobFixedID(firstRes.job_FixProblem_id);
            setinitValueorNot(true);
            setinsertOrUpdate(true);
            fetchMasterData(firstRes.owner_network_id, firstRes.cause_Id , firstRes.subCause_Id );
            onLoadGetResolutionCategoryTier3(firstRes.subCause_Id)
            //firstBindingSubCause(firstRes.cause_Id);
          } else {
            setinitValueorNot(true);
            fetchMasterData();
            
          }
        } else {
          setinitValueorNot(true);
          fetchMasterData();
        }
      })
      .catch((err) => {
        console.log(err);
        setinitValueorNot(true);
        fetchMasterData();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function fetchMasterData(ownerNetwork = null, causeid = null, subCauseId = null) {
    axios
      .all([
        ServiceApi.post("master_data/job_sla_type", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_type_id: headerdata.job_type_id,
        }),
        ServiceApi.post("master_data/job_cause", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          owner_network_id: ownerNetwork,
        }),
        ServiceApi.post("master_data/job_action_type", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_type_id: headerdata.job_type_id,
        }),
        ServiceApi.post("master_data/owner_network_single", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
        }),
        ServiceApi.post("master_data/maintain_type_single", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
        }),
        ServiceApi.post("master_data/GetResolutionCategoryTier3", {
          sub_cause_id: subCauseId,
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
        }),
      ])
      .then(
        ([
          resJobSLA,
          resJobCause,
          resActionType,
          resOwnerNetwork,
          resMaintain,
          GetResolutionCategoryTier3,
        ]) => {
          const { data: resultJobSLA } = resJobSLA;
          const { data: resultJobCause } = resJobCause;
          const { data: resultActionType } = resActionType;
          const { data: resultOwnerNetwork } = resOwnerNetwork;
          const { data: resultMainTain } = resMaintain;
          const { data: resultTier3 } = GetResolutionCategoryTier3;
          const jobSLAList = resultJobSLA?.data.result.map((s) => ({
            ...s,
            value: s.sla_id,
            label: s.sla_name,
          }));
          const jobCauseList = resultJobCause?.data.result.map((s) => ({
            ...s,
            value: s.cause_id,
            label: s.cause_name,
          }));
          const actionTypeList = resultActionType?.data.result.map((s) => ({
            ...s,
            value: s.cause_Probdetail_Fix_ID,
            label: s.cause_Probdetail_Fix_Name,
          }));
          const ownerNetwork = resultOwnerNetwork?.data.result.map((s) => ({
            ...s,
            value: s.owner_network_id,
            label: s.owner_network_name,
          }));
          const MainTain = resultMainTain?.data.result.map((s) => ({
            ...s,
            value: s.maintain_type_id,
            label: s.maintain_name,
          }));

          if (jobSLAList.length === 1) {
            form.setFieldsValue({
              jobSLA: jobSLAList[0].sla_id,
            });
          }

          if (MainTain.length === 1) {
            form.setFieldsValue({
              maintainType: MainTain[0].maintain_type_id,
            });
          }

          if (ownerNetwork.length === 1) {
            form.setFieldsValue({
              ownerNetwork: ownerNetwork[0].owner_network_id,
            });
          }

          const defaultSLA = jobSLAList.find(
            (f) =>
              f.sla_name
                .toUpperCase()
                .indexOf(headerdata.job_type_name.toUpperCase()) > -1
          );
          if (defaultSLA) {
            form.setFieldsValue({ jobSLA: defaultSLA.sla_id });
          }

          //! end new

          if (causeid !== null) {
            ServiceApi.post("master_data/job_sub_cause", {
              company_id: CompanyId,
              operator_id: OperatorId,
              project_id: ProjectId,
              cause_id: causeid,
            })
              .then(({ data: res }) => {
                const { result, data } = res;

                if (result.code === "P" || result.value === "P") {
                  const jobSubCausesList = data?.result.map((s) => ({
                    ...s,
                    value: s.sub_cause_id,
                    label: `${s.subCause_Desc1} : ${s.subCause_Desc2}`,
                  }));
                  setFormData((form) => ({
                    ...form,
                    slaList: jobSLAList,
                    jobCauses: jobCauseList,
                    actions: actionTypeList,
                    OwnerNetwork: ownerNetwork,
                    jobSubCauses: jobSubCausesList,
                    MainTain: MainTain
          
                  }));
                }
              })
              .catch((err) => console.log(err));
          } else {
            setFormData({
              ...formData,
              slaList: jobSLAList,
              OwnerNetwork: ownerNetwork,
              jobCauses: jobCauseList,
              actions: actionTypeList,
              MainTain: MainTain,
            });
          }
        }
      )
      .catch((err) => console.log(err));
  }
  const handleOwnerNetworkChange = (value) => {
    ServiceApi.post("master_data/job_cause", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      owner_network_id: value,
    }).then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        const jobCauseList = data?.result.map((s) => ({
          ...s,
          value: s.cause_id,
          label: s.cause_name,
        }));
        form.setFieldsValue({ jobCause: null });
        setFormData({
          ...formData,
          jobCauses: jobCauseList,
        });
      }
    });
  };
  const statusInfoModalCallBack = () => {
    setVisibleModal(false);
    window.location.reload();
  };
  const onLoadGetResolutionCategoryTier3 = async (value) => {
  const  LoadTier3 = await  ServiceApi.post("master_data/GetResolutionCategoryTier3", {
      sub_cause_id: value,
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
    })
    if (LoadTier3.data.result.code === "P" || LoadTier3.data.result.value === "P") {
      const jobTier3 = LoadTier3?.data.data.result.map((s) => ({
        ...s,
        value: s.tier3_id,
        label: s.description,
      }));
      setFormData((form) => ({
        ...form,
        jobTier3 : jobTier3
      }));

    }
  }      
  return (
    <>
      {initValueorNot ? (
        <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
          <Panel
            header={
              <>
                <h4>{"บันทึกสาเหตุ"}</h4>
              </>
            }
            key="1"
          >
            <div className="d-flex align-content-md-start flex-wrap w-100">
              <div className="col col-12">
                <Form
                  name="fixed_problem_form"
                  onFinish={onFinish}
                  form={form}
                  {...defaultFormItemLayout}
                  initialValues={initValueForm}
                >
                  <Form.Item
                    name="jobSLA"
                    label="SLA"
                    rules={[{ required: true, message: "กรุณาเลือก SLA" }]}
                  >
                    <Select placeholder="Select">
                      {formData.slaList.map((data, index) => (
                        <Option
                          key={`progress_detail_form_progress_${index + 1}`}
                          value={data.value}
                        >
                          <span className="default-thai-font">
                            {data.label}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="maintainType"
                    label="ประเภทงานซ่อม"
                    rules={[
                      { required: true, message: "กรุณาเลือกประเภทงานซ่อม" },
                    ]}
                  >
                    <Select placeholder="Select">
                      {formData.MainTain?.map((d, i) => (
                        <Option
                          key={`acceptance_maintain_type_index_${i}`}
                          value={d.value}
                        >
                          <span className="default-thai-font">{d.label}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="ownerNetwork"
                    label="Owner Network"
                    rules={[
                      { required: true, message: "กรุณาเลือก Owner Network" },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      onChange={handleOwnerNetworkChange}
                    >
                      {formData.OwnerNetwork?.map((d, i) => (
                        <Option
                          key={`acceptance_onwer_network_index_${i}`}
                          value={d.value}
                        >
                          <span className="default-thai-font">{d.label}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="jobCause"
                    label="Resolution Tier1"
                    rules={[
                      { required: true, message: "กรุณาเลือก Resolution Tier1" },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      onChange={handleChangeJobCause}
                    >
                      {formData.jobCauses.map((data, index) => (
                        <Option
                          key={`progress_detail_form_progress_${index + 1}`}
                          value={data.value}
                        >
                          <span className="default-thai-font">
                            {data.label}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="jobSubCause"
                    label="Resolution Tier2"
                    rules={[
                      { required: true, message: "กรุณาเลือก Resolution Tier2" },
                    ]}
                  >
                    <Select placeholder="Select" onChange={(e) => onLoadGetResolutionCategoryTier3(e) }>
                      {formData.jobSubCauses.map((data, index) => (
                        <Option
                          key={`progress_detail_form_progress_${index + 1}`}
                          value={data.value}
                        >
                          <span className="default-thai-font">
                            {data.label}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="tier3_id"
                    label="Resolution Tier3"
                    rules={[
                      { required: true, message: "กรุณาเลือก Resolution Tier3" },
                    ]}
                  >
                    <Select placeholder="Select">
                      {formData.jobTier3.map((data, index) => (
                        <Option
                          key={`progress_detail_form_progress_${index + 1}`}
                          value={data.value}
                        >
                          <span className="default-thai-font">
                            {data.label}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="action"
                    label="Action"
                    rules={[{ required: true, message: "กรุณาเลือก Action" }]}
                  >
                    <Select placeholder="Select">
                      {formData.actions.map((data, index) => (
                        <Option
                          key={`progress_detail_form_progress_${index + 1}`}
                          value={data.value}
                        >
                          <span className="default-thai-font">
                            {data.label}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="problemDetail"
                    label="สาเหตุที่พบ"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกสาเหตุที่พบ",
                      },
                    ]}
                  >
                    <Input.TextArea rows="5" />
                  </Form.Item>
                  <Form.Item
                    name="FixProblem_Result"
                    label="รายละเอียดการแก้ไข"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกรายละเอียดการแก้ไข",
                      },
                    ]}
                  >
                    <Input.TextArea rows="2" />
                  </Form.Item>
                  <Form.Item name="exclusion_detail" label="สาเหตุล่าช้า">
                    <Input.TextArea rows="2" />
                  </Form.Item>
                  <Form.Item label="Photo and Video" name="photoandvideo">
                    <Form.Item
                      style={{ border: "1px solid #d9d9d9", padding: 10 }}
                    >
                      <Upload
                        name="image"
                        listType="picture-card"
                        className="avatar-uploader"
                        action={`${process.env.REACT_APP_URL_API}mockupupload/`}
                        onChange={handleChange}
                      >
                        {uploadImg.length >= 8 ? null : (
                          <div style={{ marginTop: 8 }}>Upload</div>
                        )}
                      </Upload>
                    </Form.Item>
                  </Form.Item>
                  {/* <Form.Item
                    name="isDisable"
                    label=" "
                    colon={false}
                    valuePropName="checked"
                  >
                    <Checkbox>
                      <span>ซ่อมชั่วคราว</span>
                    </Checkbox>
                  </Form.Item> */}
                  {/* <Form.Item {...tailLayout}> */}
                  <div className="text-center">
                    {/* <Button
                      htmlType="button"
                      className="mr-3"
                      onClick={() => {
                        form.resetFields();
                        setDisableSubmit(false);
                      }}
                    >
                      Clear
                    </Button> */}
                    <Renderbtn
                      renderBtn={{
                        visible: true,
                        html_tag: "button",
                        type: "Text",
                        text: `Clear`,
                        css: "btn btn-sm btn-light",
                      }}
                      btnMiddleware={() => {
                        form.resetFields();
                        setDisableSubmit(false);
                      }}
                      index="view_btn_closemodal"
                      item={null}
                      disable={false}
                    ></Renderbtn>
                    <Renderbtn
                      renderBtn={{
                        visible: true,
                        html_tag: "button",
                        type: "ImagewithText",
                        text: `บันทึกสาเหตุเรียบร้อย`,
                        icon_align: "left",
                        image_path: "/icon/bbtec/button/md/fix-problem.svg",
                        css: "btn btn-sm btn-primary",
                      }}
                      btnMiddleware={() => form.submit()}
                      index="view_submit_form"
                      item={null}
                      disable={false}
                    ></Renderbtn>
                  </div>
                  {/* </Form.Item> */}
                </Form>
              </div>
            </div>
          </Panel>
        </Collapse>
      ) : (
        <div
          style={{
            width: "96%",
            marginLeft: "2%",
            marginTop: "1%",
            height: "400px",
          }}
        >
          <Skeleton count={1} height={400} />
        </div>
      )}

      <Modal
        title={null}
        centered
        visible={visibleModal}
        footer={null}
        closable={false}
      >
        {disableSubmit ? (
          // <LoadingContent
          //   setModalshow={setVisibleModal}
          //   spin={spin}
          //   Text={loadingText}
          //   hasError={hasError}
          // ></LoadingContent>
          <StatusInfo
            showSpinIcon={spin}
            statusText={loadingText}
            mode={statusInfoMode}
            callbackFunction={statusInfoModalCallBack}
          ></StatusInfo>
        ) : (
          <div className="text-center">
            <img
              src={ServiceApi.absoluteUrl("/img/modal_approve.svg")}
              className="img-fluid"
              alt=""
            />
            <h3 className="font-mont-sb fs-18 c-blue mt-3">
              Save data Success
            </h3>
            <button
              onClick={() => setVisibleModal(false)}
              className="btn btn-secondary"
            >
              OK
            </button>
          </div>
        )}
      </Modal>
      <Fixproblemdetail
        key={`detail_fixProblem_index`}
        headerdata={headerdata}
        jobData={jobData}
        rereder={reRenderFixProblemList}
        CompanyId={CompanyId}
        OperatorId={OperatorId}
        ProjectId={ProjectId}
      ></Fixproblemdetail>
    </>
  );
};

export default FixedProblem;
